const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
   <style>
        .search-webinar-header {
            background: linear-gradient(to left, #5494f9, #3570d2);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px 0;
        }

        .search-webinar-container {
            width: 1000px;
        }

        .category-page {
            margin: 0px;
            font-weight: 400;
            font-size: 14px;
            color: white;
            line-height: 19px;
        }

        .search-webinar-container h1 {
            margin: 20px 0px 0px 0px;
            color: white;
            line-height: 32px;
        }

        ul {
            list-style-type: none;
            margin: 18px 0px 0px 0px;
            padding: 0px;
            margin-bottom: 24px;
        }

        ul li {
            list-style-type: none;
            margin-right: 32px;
            vertical-align: middle;
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            color: white;
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
        }

        ul li img {
            margin-right: 12px;
        }
   </style>
 </template>`;

styleElement.register("search-webinar-header-style");